export var getHome = function() {
    return window.location.origin;
};
